import { useState } from "react";
import "./App.css";
import { ThemeProvider } from "styled-components";
import * as themes from "./themes";
import ThemeContext from "./themes/context";
import Theme from "./themes/theme";
import GlobalStyle from "./globalStyles";
import GlobalContenxt from "./context/globalContext/globalContext";
import initial from "./context/globalContext/initial";
import GlobalContextDefinition from "./context/globalContext/GlobalContextDefinition";
import Router from "./routes/Router";
import CheckoutContext from "./context/checkoutContext/checkoutContext";
import CheckoutContextDefinition from "./context/checkoutContext/CheckoutContextDefinition";
import initialCheck from "./context/checkoutContext/initial";

const App = () => {
	const [theme] = useState<Theme>(themes.vitat);
	const [globalContext, setGlobalContext] = useState<GlobalContextDefinition>({
		...initial,
		setContext: (newValue: { [key: string]: unknown }) => {
			setGlobalContext({
				...globalContext,
				...newValue,
			});
		},
	});

	const [checkoutContext, setCheckoutContext] = useState<CheckoutContextDefinition>({
		...initialCheck,
		setContext: (newValue: { [key: string]: unknown }) => {
			setCheckoutContext({
				...checkoutContext,
				...newValue,
			});
		},
	});

	return (
		<div className="App">
			<ThemeContext.Provider value={theme}>
				<GlobalContenxt.Provider value={globalContext}>
					<CheckoutContext.Provider value={checkoutContext}>
						<ThemeContext.Consumer>
							{(theme: Theme) => (
								<ThemeProvider theme={theme}>
									<GlobalStyle />
									<Router />
								</ThemeProvider>
							)}
						</ThemeContext.Consumer>
					</CheckoutContext.Provider>
				</GlobalContenxt.Provider>
			</ThemeContext.Provider>
		</div>
	);
};

export default App;
